<template>
  <MtxPage width="sm" class="token-info">
    <template #header>
      <h1>The Matryx Token Info</h1>
      <i>A Mainnet Ethereum ERC20 Token</i>
    </template>

    <MtxCard>
      <p>
        The Matryx Token (MTX) is an ERC20 token on the Ethereum Blockchain Network. The MTX token
        is used as a utility token to interact with and access the Matryx platform.
      </p>

      <div class="mt-4 text-center">
        <h6 class="mb-1">Matryx Token Smart Contract Address</h6>
        <a
          class="token-info__address"
          target="_blank"
          :href="`https://etherscan.io/token/${tokenAddress}`"
        >
          {{ tokenAddress }}
        </a>
      </div>

      <div class="mt-4">
        <ul class="list-plain">
          <li
            class="mb-2 flex align-center justify-between"
            v-for="(item, index) in tokenInfo"
            :key="index"
          >
            <span class="pr-1">
              <b>{{ item.title }}</b>
              <br />
              <small v-if="item.extra">({{ item.extra }})</small>
            </span>
            <span class="heading-6 text-right">{{ item.value }} MTX</span>
          </li>
        </ul>
      </div>
      <div v-if="web3.available" class="text-center mt-4">
        <button @click="watchToken()">
          Add Token to MetaMask
        </button>
      </div>
    </MtxCard>
  </MtxPage>
</template>

<script>
import web3 from "@/mixins/web3"

export default {
  mixins: [web3],

  data: () => ({
    tokenAddress: "0x0af44e2784637218dd1d32a322d44e603a8f0c6a",
    tokenInfo: [
      {
        title: "Real Total Supply",
        value: "34,432,385"
      },
      {
        title: "Total Circulating Supply",
        extra: "held by public",
        value: "23,224,303"
      },
      {
        title: "Matryx Affiliates Allocation",
        extra: "held by team",
        value: "11,208,082"
      },
      {
        title: "Total Tokens Burned",
        value: "279,726,879"
      }
    ]
  }),

  metaInfo: {
    titleTemplate: "%s | Token Information",
    meta: [
      {
        name: "descripton",
        content:
          "The Matryx token (MTX) is an ERC20 token on the Ethereum network. The MTX token is used to exchange value between users on the Matryx platform."
      },
      {
        property: "og:title",
        content: "The Matryx Token (MTX)"
      }
    ]
  },

  methods: {
    async watchToken() {
      const Token = await this.contracts.Token
      const provider = window.web3.currentProvider

      provider.sendAsync(
        {
          method: "metamask_watchAsset",
          params: {
            type: "ERC20",
            options: {
              address: Token.address,
              symbol: "MTX",
              decimals: 18
              // image: tokenImage // TODO
            }
          },
          id: Date.now()
        },
        () => {} // noop
      )
    }
  }
}
</script>

<style lang="scss">
.token-info {
  .heading-6 {
    font-weight: normal;
  }

  &__address {
    overflow-wrap: break-word;
  }
}
</style>
